import { css } from '@emotion/react';
import { tokens } from '@hotjar/hotsauce';

export const buttonStyles = css`
  overflow: hidden;
  width: 100%;
  max-width: 368px;
  padding-left: ${tokens.spacer.x6};
  justify-content: center;
`;

export const containerStyles = css`
  position: relative;
`;

const BORDER_HEIGHT = 1;

export const iconWrapperStyles = css`
  position: absolute;
  top: ${BORDER_HEIGHT}px;
  left: ${BORDER_HEIGHT}px;

  background-color: ${tokens.color.ui_background};
  border-bottom-left-radius: ${tokens.spacer.x0};
  border-top-left-radius: ${tokens.spacer.x0};
  cursor: pointer;

  height: calc(100% - ${2 * BORDER_HEIGHT}px);
  width: 46px;

  display: flex;
  justify-content: center;
  align-items: center;
`;

// colors from Google styleguide
const GOOGLE_COLOR = '#4285f4';
const GOOGLE_HOVER_COLOR = '#3872d9';

export const googleButtonStyles = css`
  background-color: ${GOOGLE_COLOR};
  &:hover {
    background-color: ${GOOGLE_HOVER_COLOR};
  }
`;

export const googleIconWrapperStyles = css`
  &:hover {
    & + button {
      background-color: ${GOOGLE_HOVER_COLOR};
    }
  }
`;

export const samlSsoButtonStyles = css`
  background-color: ${tokens.color.neutral_700};
  &:hover {
    background-color: ${tokens.color.neutral_800};
  }
`;

export const samlSsoIconWrapperStyles = css`
  &:hover {
    & + button {
      background-color: ${tokens.color.neutral_800};
    }
  }
`;
